import {ArtEntryDto, CategoryDto} from "./model/dto";
import RestService, {ErrorDetails, ResponseStatus, RestCall} from "./restService";

const API_BASE = "https://artportfoliofunction-o3qyavvdxq-oa.a.run.app";

async function getGalleryData(
    onSuccess: (a: ResponseStatus<ArtEntryDto[]>) => Promise<any>,
    onFailure: (restCall: RestCall, error: ErrorDetails) => Promise<any>) {
    await RestService.doUnauthenticatedCall({
            url: API_BASE + "/portfolio/art",
            method: "get",
            headers: {}
        } as RestCall,
        onSuccess,
        onFailure);
}

async function getCategories(
    onSuccess: (a: ResponseStatus<CategoryDto[]>) => Promise<any>,
    onFailure: (restCall: RestCall, error: ErrorDetails) => Promise<any>) {
    await RestService.doUnauthenticatedCall({
            url: API_BASE + "/portfolio/categories",
            method: "get",
            headers: {}
        } as RestCall,
        onSuccess,
        onFailure);
}

const GalleryApiService = {
    getGalleryData,
    getCategories
};
export default GalleryApiService;
